<h2 matDialogTitle data-cy="transfer-dialog-title">Convert to Hire Contract</h2>

<mat-dialog-content>
  <div fxLayout="column">
    <p data-cy="transfer-dialog-description">
      Please confirm or assign the correct items before proceeding to put them
      on hire.
    </p>
    <assign-items-table [booking]="booking" (itemsFormSet)="formSet($event)" (itemFormArray)="formArraySet($event)"
      data-cy="assign-items-table"></assign-items-table>
  </div>

  <app-alert-text type="warning" data-cy="transfer-warning">
    <p class="font-bold">Warning</p>
    <p>
      These items will be marked as on hire immediately with the current date
      and time as their "On Hire" time, they will not be available for other
      hires, and this booking will be closed.
    </p>
  </app-alert-text>
</mat-dialog-content>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close type="button" data-cy="transfer-cancel-button">Cancel</button>
  <button mat-flat-button color="primary" [disabled]="!formGroup || !formGroup.valid || saving" (click)="save()"
    data-cy="transfer-convert-button">
    Convert
  </button>
</div>